export default __webpack_public_path__ + "static/media/jsES6.7091dd85.jpg";